/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_UnlockInputs */

const cs_share_unlock = /** @type {(inputs: Share_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odemknout`)
};

const en_share_unlock = /** @type {(inputs: Share_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlock`)
};

/**
* | output |
* | --- |
* | "Unlock" |
*
* @param {Share_UnlockInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const share_unlock = /** @type {((inputs?: Share_UnlockInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_UnlockInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_unlock(inputs)
	return cs_share_unlock(inputs)
});